import React, { useEffect, useState } from "react";
import { Modal, Checkbox, Button } from "antd";
import { toast } from "react-toastify";
import { customLogger } from "../../../../utils/Logger";
import ENDPOINTS from "../../../../services/endpoint";
import apiInstance from "../../../../services/apiService";
import "./index.css";

interface EditModalProps {
  visible: boolean;
  onClose: () => void;
  onAfterClose: () => void;
  data: {
    blockCallType: number;
    calls: boolean;
    createdDate: string;
    phoneNumber: string;
    sms: boolean;
    _id: string;
  } | null;
}

const EditModal: React.FC<EditModalProps> = ({ visible, onClose, onAfterClose, data }) => {
  const [selectedOptions, setSelectedOptions] = useState<string[]>([]);
  const [loading, setLoading] = useState(false);
  const [currentPhoneNumber, setCurrentPhoneNumber] = useState<string | null>(
    null
  );

  const handleCheckboxChange = (checkedValues: string[]) => {
    setSelectedOptions(checkedValues);
  };

  const handleUpdate = async () => {
    const url = ENDPOINTS.BLOCK_NUMBER + "/" + data?._id;

    setLoading(true);

    try {
      const response = await apiInstance.patch(url, {
        phoneNumber: currentPhoneNumber,
        calls: selectedOptions.includes("calls"),
        sms: selectedOptions.includes("sms"),
      });
      toast.success("Phone Number updated successfully!");
      onClose();
    } catch (error) {
      customLogger(error);
      toast.error("There was an error updating");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (data) {
      setCurrentPhoneNumber(data.phoneNumber);
      const initialValues = [];
      if (data.calls) initialValues.push("calls");
      if (data.sms) initialValues.push("sms");
      setSelectedOptions(initialValues);
    }
  }, [data]);

  return (
    <Modal
      title="Add New Block Number"
      open={visible}
      onCancel={onClose}
      afterClose={onAfterClose}
      footer={null}
      centered
      width={300}
      className="block-number-modal"
    >
      <Checkbox.Group
        value={selectedOptions}
        onChange={handleCheckboxChange}
        className="block-options"
      >
        <Checkbox value="calls">Call</Checkbox>
        <Checkbox value="sms">SMS</Checkbox>
      </Checkbox.Group>
      <Button
        loading={loading}
        onClick={handleUpdate}
        type="primary"
        style={{
          background:
            "linear-gradient(rgb(196, 53, 200) 34.17%, rgb(94, 104, 240) 100%)",
          marginTop: "16px",
          width: "100%",
          border: 'none'
        }}
      >
        Block
      </Button>
    </Modal>
  );
};

export default EditModal;
